<template>
  <div class="alert row row--light">
    <icon
      icon-name="alert-circle"
      view-box="0 0 24 24"/>
    <p class="alert--text">{{ text }}</p>
  </div>
</template>
<script>
import Icon from "StyleguideComponents/Icon.vue";

export default {
  name: "Alert",
  components: {
    Icon
  },
  props: {
    textProp: {
      type: String,
      required: true,
      default: "Uh oh! There was an error."
    }
  },
  computed: {
    text() {
      return this.textProp;
    }
  }
};
</script>
